import SaveViewPopupController from './popup/popup.controller';

const saveViewPopupTemplate = require('./popup/popup.html');

/** @ngInject */
export default function saveViewDirectiveConfig(DialogService) {
    function link($scope, $element) {
        function showSaveViewPopup(ev) {
            DialogService.show({
                controller: SaveViewPopupController,
                controllerAs: 'ctrl',
                template: saveViewPopupTemplate,
                parent: document.body,
                targetEvent: ev,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    searchQuery: $scope.searchQuery,
                    onSaveView: $scope.onSaveView
                }
            });
        }

        $element.on('click', showSaveViewPopup);

        $element.on('$destroy', () => {
            $element.off('click', showSaveViewPopup);
        });
    }

    return {
        restrict: 'A',
        scope: {
            searchQuery: '<',
            onSaveView: '&'
        },
        link
    };
}



// WEBPACK FOOTER //
// ./app/common/save-view/save-view.directive.js